require("./gauge/GaugeSeries");

require("./gauge/GaugeView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/chart/gauge.js
// module id = VCT1
// module chunks = 0